const getOptionalValue = (target, fields) => {
  const [currentField, ...remainingFields] = fields;
  if (target) {
    if (remainingFields.length === 0) {
      return target[currentField];
    }
    return getOptionalValue(target[currentField], remainingFields);
  }
  return undefined;
};
export default (target, field) => getOptionalValue(target, field.split('.'));